import { render, staticRenderFns } from "./CustomEmpty.vue?vue&type=template&id=7828c90e&"
import script from "./CustomEmpty.vue?vue&type=script&lang=js&"
export * from "./CustomEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports